import {
  DevelopmentPathCycleStateDto,
  DevelopmentPlanStatusDto,
  EmployeeProfileRoleDto,
} from '@/api/generated';
import { EmployeeProfileDevelopmentChatFormSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/developmentChat/employeeProfile.chat.translation.en.ts';

export const employeeProfileDevelopmentChatFormSectionTranslation: EmployeeProfileDevelopmentChatFormSectionTranslation =
  {
    content: {
      chat: {
        actions: {
          completeMilestone: 'OZNACZ JAKO ZAKOŃCZONE: {{milestone}}',
          deleteMilestone: 'USUŃ: {{milestone}}',
          editMilestone: 'EDYTUJ: {{milestone}}, zgodnie z rekomendacjami:',
        },
        backToPaths: 'Zapisz plan i wyjdź',
        confirmSending:
          'Czy na pewno chcesz wysłać plan do przełożonego? Nie będziesz mógł go edytować, dopóki przełożony go nie sprawdzi.',
        content: {
          form: {
            enterMessage: 'Napisz wiadomość...',
            fastQuestions: 'Szybkie skróty',
            streamingError: 'Wystąpił błąd, proszę spróbować ponownie później',
            submitButton: 'Rozpocznij',
          },
          noMessages:
            'Cześć, rozpoczynasz tworzenie planu rozwoju. Twój plan powinien zawierać od 2 do 5 kroków, które pomogą Ci osiągnąć zamierzony cel. Pomogę Ci w tym procesie.',
          shortcuts: {
            suggestedPrompt: {
              buttonText: 'Sugerowany prompt startowy',
              onClickText:
                'Szukam wsparcia w przygotowaniu planu rozwoju zawodowego. Chcę podejść do tego strategicznie - zidentyfikować cele, określić niezbędne kompetencje i stworzyć harmonogram działań. Czy możesz być moim przewodnikiem w tym procesie?',
            },
            updateMilestones: {
              buttonText: 'Aktualizuj plan',
              onClickText: 'AKTUALIZUJ plan w oparciu o treść z czatu',
            },
          },
        },
        developmentDirection: 'Zaplanowany kierunek rozwoju',
        developmentPathInfo: 'Plan rozwojowy',
        editModeLabel: 'Tryb edycji',
        editModeWarning:
          'Włączenie trybu edycji, pozwoli na zmodyfikowanie planu rozwoju. Spowoduje to anulowanie ukończenia planu i powiadomienie przełożonego.',
        error: {
          notInEditMode: 'Musisz być w trybie edycji, aby zaktualizować plan rozwoju.',
          stepsRequirement: 'Twój plan rozwoju musi zawierać co najmniej 2 kroki.',
        },
        headerDescription: 'Pomagam Ci rozwijać się w kierunku: {{developmentDirection}}',
        headerTitle: 'Asystent tworzenia planu rozwojowego',
        leaveChatConfirmation:
          'Czy na pewno chcesz opuścić czat? Historia czatu zostanie utracona.',
        noDevelopmentPath: 'Brak szczegółowego kierunku rozwoju, utwórz nowy aby rozpocząć.',
        planPreview: 'Podgląd planu',
        sendToSupervisor: 'Wyślij plan do przełożonego',
        welcomeMessage:
          'Cześć! Jestem tutaj, aby pomóc Ci stworzyć twój plan rozwoju. Co mogę dla ciebie zrobić?',
      },
      competencyDevelopment: {
        actions: 'Działania',
        completed: 'Ukończono',
        completedAt: 'Ukończono',
        milestone: 'Kamień milowy',
        step: 'Krok',
      },
      cycleSelection: {
        askSupervisor: 'Poproś przełożonego o utworzenie kierunku rozwoju.',
        createFirstCycle: 'Utwórz swoją pierwszą ścieżkę rozwoju, aby rozpocząć czat.',
        createPathsCyclesForm: {
          cancelButton: 'Anuluj',
          developmentDirection: 'Kierunek rozwoju',
          numberOfMonths: 'Liczba miesięcy',
          placeholder: 'Wprowadź kierunek planu rozwojowego',
          submitButton: 'Zapisz kierunek',
          submitEditButton: 'Zapisz zmiany',
          validFrom: 'Ważne od',
          validTo: 'Ważne do',
        },
        cycle: 'Ścieżka',
        noDevelopmentCycles: 'Brak ścieżek rozwoju.',
        selectDevelopmentCycle: 'Wybierz ścieżkę rozwoju',
      },
      developmentPath: {
        acceptanceForm: {
          acceptPlan: 'Zaakceptuj plan',
          cancel: 'Anuluj',
          comment: 'Komentarz',
          completeBlockedReason: 'Ukończ wszystkie kroki, aby zakończyć plan',
          confirmReject: 'Potwierdź odrzucenie',
          rejectPlan: 'Odrzuć plan',
          submitBlockedReason: 'Plan musi mieć min. 2 ścieżki rozwoju',
        },
        changeState: {
          [DevelopmentPathCycleStateDto.Cancelled]: 'Anuluj',
          [DevelopmentPathCycleStateDto.Completed]: 'Zakończ',
          [DevelopmentPathCycleStateDto.Draft]: 'Cofnij do szkicu',
          [DevelopmentPathCycleStateDto.ReadyForRealization]: 'W realizacji',
          [DevelopmentPathCycleStateDto.SupervisorApproved]: 'Zatwierdź plan',
          [DevelopmentPathCycleStateDto.SupervisorRejected]: 'Odrzuć plan',
        },
        chatNotAvailable: 'Czat nie jest teraz dostępny z powodu: {{reason}}',
        chatNotAvailableReasonRole: 'Nie masz uprawnień do edycji tego planu rozwoju.',
        chatNotAvailableReasonState: 'Obecny status planu nie pozwala na jego edycję.',
        continueChat: 'Edytuj indywidualny plan rozwoju',
        createdBy: 'Utworzony przez',
        currentStatus: 'Bieżący status',
        developmentDirection: 'Kierunek rozwoju',
        duration: 'Czas trwania',
        editPath: 'Edytuj kierunek rozwoju',
        history: {
          by: 'Przez',
          noHistory: 'Brak historii zmian statusu.',
          title: 'Historia',
        },
        months: 'miesięcy',
        preview: 'Plan rozwojowy',
        startChat: 'Stwórz indywidualny plan rozwoju',
        title: 'Status planu rozwoju',
      },
      infoChip: {
        [EmployeeProfileRoleDto.Admin]: {
          [DevelopmentPlanStatusDto.ReadyForRealization]: 'Zatwierdź plan rozwojowy',
        },
        [EmployeeProfileRoleDto.Owner]: {
          [DevelopmentPlanStatusDto.SupervisorApproved]: 'Zacznij realizować plan rozwojowy',
          [DevelopmentPlanStatusDto.SupervisorRejected]:
            'Popraw plan rozwojowy na podstawie komentarza od przełożonego',
        },
        [EmployeeProfileRoleDto.P1]: {
          [DevelopmentPlanStatusDto.ReadyForRealization]: 'Zatwierdź plan rozwojowy',
        },
        noState: 'Rozpocznij pracę nad planem rozwojowym',
      },
      pathPreview: {
        changeState: {
          pathCompleted: 'Zakończ ścieżkę',
          pathFinished: 'Ścieżka została zakończona!',
          pathInProgress: 'Rozpocznij realizację',
        },
        markAsDone: 'Oznacz jako ukończone',
        markAsUndone: 'Oznacz jako nieukończone',
        milestonesActions: 'Działania:',
        milestonesCount: '{{completedMilestones}} z {{totalMilestones}} ukończono',
        milestonesProgress: 'Postęp realizacji kamieni milowych',
        pathRejected:
          'Ścieżka została odrzucona przez przełożonego. Proszę poprawić błędy zgodnie z uwagami, a następnie przesłać ponownie do akceptacji.',
        previewTitle: 'Podgląd planu rozwoju',
        status: {
          inProgress: 'REALIZACJA PLANU ROZWOJOWEGO',
          notStarted: 'PLAN ROZWOJOWY JESZCZE NIE ZOSTAŁ UTWORZONY',
        },
        timelineMarkers: {
          meetings: {
            mdrFeedback: 'Spotkanie feedbackowe MDR',
            pmcSummary: 'Spotkanie podsumowujące PMC',
            sopSummary: 'Spotkanie podsumowujące SOP',
          },
          months: {
            april: 'KWIECIEŃ',
            august: 'SIERPIEŃ',
            january: 'STYCZEŃ',
          },
        },
      },
    },
    headerTitle: 'Tworzenie planu rozwojowego',
    headerTitleShorter: 'Tworzenie planu rozwojowego',
  };
